(() => {
  if (window.sekagePagesReady) return;
  window.sekagePagesReady = true;
  function setup(root = document) {
    const app = root.querySelector('#AVADA_PAGE_FAQS');
    if (app && !app.dataset.skLabelReady) {
      const labelSearch = () => {
        const input = app.querySelector('.Avada-Faq_Search-Box');
        const header = app.querySelector('.Avada-Faq_Header');
        if (!input || !header) return false;
        input.id = input.id || 'sk-faq-app-search';
        const label = document.createElement('label');
        label.className = 'sk-faq-app-label';
        label.htmlFor = input.id;
        label.textContent = 'Find an answer';
        header.insertBefore(label, header.querySelector('.Avada-Faq_Search'));
        app.dataset.skLabelReady = 'true';
        return true;
      };
      if (!labelSearch()) {
        const observer = new MutationObserver(() => {
          if (labelSearch()) observer.disconnect();
        });
        observer.observe(app, {childList:true, subtree:true});
      }
    }
    root.querySelectorAll('[data-sk-faq]').forEach(section => {
      if (section.dataset.searchReady) return;
      section.dataset.searchReady = 'true';
      const search = section.querySelector('[data-sk-faq-search]');
      const items = [...section.querySelectorAll('.sk-faq__item')];
      const results = section.querySelector('[data-sk-faq-results]');
      const empty = section.querySelector('[data-sk-faq-empty]');
      if (!search || !results || !empty) return;
      search.addEventListener('input', () => {
        const terms = search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        let count = 0;
        items.forEach(item => {
          const text = item.textContent.toLocaleLowerCase();
          item.hidden = !terms.every(term => text.includes(term));
          if (!item.hidden) count++;
        });
        empty.hidden = count > 0;
        results.textContent = terms.length ? `${count} ${count === 1 ? 'answer' : 'answers'} found` : '';
      });
    });
    setupInfo(root);
  }
  // Information pages: plain-text emails in admin content become links, the current
  // help chip scrolls into view on phones, and the on-this-page index follows the reader.
  function setupInfo(root) {
    root.querySelectorAll('.sk-info__main a:not([href])').forEach(link => {
      const email = link.textContent.trim();
      if (/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) link.href = `mailto:${email}`;
    });
    const nav = root.querySelector('[data-sk-info-nav]');
    const current = nav && nav.querySelector('[aria-current="page"]');
    if (current && nav.scrollWidth > nav.clientWidth) {
      nav.scrollLeft = current.offsetLeft - nav.offsetLeft - parseFloat(getComputedStyle(nav).paddingLeft);
    }
    const toc = root.querySelector('[data-sk-info-toc]');
    if (!toc || toc.dataset.skReady || !('IntersectionObserver' in window)) return;
    toc.dataset.skReady = 'true';
    const links = new Map();
    toc.querySelectorAll('a[href^="#"]').forEach(link => {
      const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (heading) links.set(heading, link);
    });
    const list = toc.querySelector('ol');
    const visible = new Set();
    const mark = () => {
      const headings = [...links.keys()];
      const active = headings.find(heading => visible.has(heading))
        || headings.filter(heading => heading.getBoundingClientRect().top < 0).pop();
      links.forEach((link, heading) => {
        if (heading !== active) return link.removeAttribute('aria-current');
        link.setAttribute('aria-current', 'true');
        if (list && (link.offsetTop < list.scrollTop || link.offsetTop + link.offsetHeight > list.scrollTop + list.clientHeight)) {
          list.scrollTop = link.offsetTop - list.clientHeight / 2;
        }
      });
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      mark();
    }, {rootMargin: '-110px 0px -55% 0px'});
    links.forEach((link, heading) => observer.observe(heading));
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));

  // Product page gallery, variant mode (snippets/product-images.liquid renders [data-sk-variant-gallery]
  // with up to 8 slides: the selected variant's image, then up to 7 explanatory images). On a variant change, slide 1
  // and thumbnail 1 take the new variant's image. This runs in the capture phase of the bridge's
  // `variant-change` event, i.e. before Turbo's selectCallback, so Turbo's own lookup of
  // [data-image-id="<variant media id>"] finds slide 1 (data-index 0) and selects it.
  const swapImage = (img, media, src) => {
    if (!img) return;
    const lazy = img.hasAttribute('data-src') || img.hasAttribute('data-srcset');
    if (lazy) {
      img.setAttribute('data-src', src);
      img.setAttribute('data-srcset', media.srcset);
    }
    img.setAttribute('srcset', media.srcset);
    img.setAttribute('src', src);
    img.setAttribute('alt', media.alt || '');
    img.setAttribute('width', media.width);
    img.setAttribute('height', media.height);
    if (img.hasAttribute('data-aspectratio')) img.setAttribute('data-aspectratio', `${media.width}/${media.height}`);
  };
  document.addEventListener('variant-change', event => {
    const form = event.target;
    const variant = event.detail?.variant;
    if (!variant || !(form instanceof Element)) return;
    const wrap = form.closest('.js-product-section')?.querySelector('[data-product-gallery-wrapper][data-sk-variant-gallery]');
    const source = wrap?.querySelector('[data-sk-variant-gallery-media]');
    const slide = wrap?.querySelector('[data-sk-lead-slide]');
    if (!source || !slide) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch (error) { return; }
    const id = String(variant.featured_media?.id || data.fallback || '');
    const media = data.media?.[id];
    if (!media || slide.dataset.mediaId === id) return;

    slide.dataset.mediaId = id;
    const img = slide.querySelector('img.product-gallery__image');
    swapImage(img, media, media.src);
    if (img) {
      img.setAttribute('data-image-id', id);
      img.setAttribute('data-zoom-src', media.zoom);
    }
    const container = slide.querySelector('.image__container');
    if (container) container.style.maxWidth = `${media.width}px`;
    slide.querySelector('a.lightbox')?.setAttribute('href', media.zoom);

    const thumb = wrap.querySelector('[data-sk-lead-thumb]');
    if (thumb) {
      thumb.dataset.mediaId = id;
      thumb.dataset.title = media.alt || '';
      swapImage(thumb.querySelector('.image-element__wrap img'), media, media.thumb);
      const thumbWrap = thumb.querySelector('.image-element__wrap');
      if (thumbWrap) thumbWrap.style.maxWidth = `${media.width}px`;
    }

    // adaptiveHeight: re-measure once the new image has its size.
    const gallery = slide.closest('.js-product-gallery');
    const resize = () => {
      const slider = gallery && window.Flickity?.data(gallery);
      slider?.resize();
    };
    if (img && !img.complete) img.addEventListener('load', resize, {once: true});
  }, true);

  // Product page gallery, colour sets (snippets/product-images.liquid renders [data-sk-color-sets], for now on the
  // Sekage Power Bank only). Every slide and thumbnail carries data-sk-color-set="<lead media id>" and
  // [data-sk-color-sets-map] maps variant id -> lead media id. Only the selected colour's set takes part in Turbo's
  // two Flickity carousels: the other cells are removed from both (kept here in their original order) and the chosen
  // set is appended, then slide 1 is selected. Like the Slim handler above, this runs in the capture phase of
  // `variant-change`, before Turbo's selectCallback; the visible slides' data-index is renumbered (attribute and
  // jQuery's data cache, which Turbo reads) so Turbo's own [data-image-id] lookup selects the right cell.
  // On load the set is applied as soon as Turbo builds the carousels. Without the map nothing happens.
  const colorSets = new WeakMap();
  const flickityOf = element => element && (window.Flickity?.data(element) || window.jQuery?.(element).data('flickity'));
  const readColorSets = wrap => {
    if (colorSets.has(wrap)) return colorSets.get(wrap);
    let map = null;
    try { map = JSON.parse(wrap.querySelector('[data-sk-color-sets-map]')?.textContent || 'null'); } catch (error) { map = null; }
    const gallery = wrap.querySelector('[data-product-gallery]');
    const state = map && typeof map === 'object' && gallery ? {
      map,
      gallery,
      nav: wrap.querySelector('[data-product-gallery-thumbnails]'),
      slides: [...gallery.querySelectorAll('.gallery-cell[data-sk-color-set]')],
      thumbs: [...wrap.querySelectorAll('[data-product-gallery-thumbnails] .gallery-cell[data-sk-color-set]')],
      lead: null,
      applied: null
    } : null;
    colorSets.set(wrap, state);
    return state;
  };
  // Sets are disjoint, so a switch appends the whole new set first and then removes the old one (never zero cells).
  const swapCells = (slider, cells) => {
    const current = slider.getCellElements();
    const add = cells.filter(cell => !current.includes(cell));
    const drop = current.filter(cell => !cells.includes(cell));
    add.forEach(cell => cell.classList.remove('is-selected', 'is-nav-selected'));
    if (add.length) slider.append(add);
    if (drop.length) slider.remove(drop);
  };
  const applyColorSet = (state, lead) => {
    const slides = state.slides.filter(cell => cell.dataset.skColorSet === lead);
    if (!slides.length) return;
    const thumbs = state.thumbs.filter(cell => cell.dataset.skColorSet === lead);
    const mark = (cell, shown) => {
      cell.hidden = !shown;
      cell.toggleAttribute('data-sk-color-set-hidden', !shown);
    };
    state.slides.forEach(cell => mark(cell, slides.includes(cell)));
    state.thumbs.forEach(cell => mark(cell, thumbs.includes(cell)));
    slides.forEach((slide, index) => slide.querySelectorAll('[data-index]').forEach(element => {
      element.setAttribute('data-index', index);
      window.jQuery?.(element).data('index', index);
    }));
    state.lead = lead;
    const slider = flickityOf(state.gallery);
    if (!slider || state.applied === lead) return;
    state.applied = lead;
    swapCells(slider, slides);
    const nav = flickityOf(state.nav);
    if (nav) {
      swapCells(nav, thumbs);
      // Turbo's own "show only selected variant image" hides the thumbnail arrows below 5 thumbnails.
      state.nav.classList.toggle('flickity-hide-prev-next', thumbs.length < 5);
    } else if (state.nav) {
      // Static thumbnail strip: Turbo maps a click to the thumb's DOM index, so only the set stays in it, in order.
      state.thumbs.forEach(cell => { if (!thumbs.includes(cell)) cell.remove(); });
      thumbs.forEach(cell => state.nav.append(cell));
    }
    slider.select(0, false, true);
    const img = slides[0].querySelector('img');
    if (img && !img.complete) img.addEventListener('load', () => { if (!slider.isAnimating) slider.resize(); }, {once: true});
  };
  const setupColorSets = (root = document) => {
    root.querySelectorAll('[data-product-gallery-wrapper][data-sk-color-sets]').forEach(wrap => {
      const state = readColorSets(wrap);
      if (!state || state.watching) return;
      state.watching = true;
      // Page load: the variant in the product form (?variant=), else the set the server left visible.
      const id = wrap.closest('.js-product-section')?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const fromForm = id && state.map[id] != null ? String(state.map[id]) : '';
      const lead = state.slides.some(cell => cell.dataset.skColorSet === fromForm) ? fromForm
        : state.slides.find(cell => !cell.hasAttribute('data-sk-color-set-hidden'))?.dataset.skColorSet;
      if (!lead) return;
      applyColorSet(state, lead);
      if (state.applied || !('MutationObserver' in window)) return;
      // Turbo builds both carousels in one task after Flickity loads; this runs right after, before the next paint.
      const run = () => {
        applyColorSet(state, state.lead || lead);
        if (state.applied) watch.disconnect();
      };
      const watch = new MutationObserver(run);
      watch.observe(state.gallery, {attributes: true, attributeFilter: ['class']});
      addEventListener('load', run, {once: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupColorSets());
  else setupColorSets();
  document.addEventListener('shopify:section:load', event => setupColorSets(event.target));
  document.addEventListener('variant-change', event => {
    const form = event.target;
    const variant = event.detail?.variant;
    if (!variant || !(form instanceof Element)) return;
    const wrap = form.closest('.js-product-section')?.querySelector('[data-product-gallery-wrapper][data-sk-color-sets]');
    const state = wrap && readColorSets(wrap);
    const lead = state?.map[String(variant.id)];
    if (lead == null) return;
    applyColorSet(state, String(lead));
  }, true);

  // Product page add-ons and the Add to Cart price (snippets/product.liquid, product-form.liquid). Per product scope
  // ([data-sk-product-scope]): the button shows the selected variant's price plus every switched-on add-on, and the
  // struck "was" total when it is higher. All amounts come from the product JSON and the switches' data attributes;
  // the shop's money format comes from the button (data-sk-money-format). The cart request itself is in
  // sekage-navigation.js. Turbo's selectCallback rewrites only the button's spans, so the strong/s/b price parts stay.
  const atcVariants = new WeakMap();
  const atcLocked = new WeakSet();
  const moneyText = (format, cents) => {
    const pattern = String(format || '').replace(/<[^>]*>/g, '');
    if (pattern && typeof window.Shopify?.formatMoney === 'function') return window.Shopify.formatMoney(cents, pattern);
    const delimit = (precision, thousands, decimal) => {
      const [whole, part] = ((Number(cents) || 0) / 100).toFixed(precision).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (part ? decimal + part : '');
    };
    const values = {
      amount: () => delimit(2, ',', '.'),
      amount_no_decimals: () => delimit(0, ',', '.'),
      amount_with_comma_separator: () => delimit(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => delimit(0, '.', ','),
      amount_with_space_separator: () => delimit(2, ' ', ','),
      amount_with_apostrophe_separator: () => delimit(2, "'", '.')
    };
    if (!/\{\{\s*\w+\s*\}\}/.test(pattern)) return delimit(2, ',', '.');
    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => (values[key] || values.amount)());
  };
  const scopeVariant = scope => {
    if (atcVariants.has(scope)) return atcVariants.get(scope);
    const form = scope.querySelector('[data-product-form]');
    let variant = null;
    try {
      const blob = form?.querySelector('[data-kit-selected-variant]');
      variant = blob ? JSON.parse(blob.textContent.trim() || 'null') : JSON.parse(form?.dataset.product || 'null')?.variants?.[0] || null;
    } catch (error) { variant = null; }
    atcVariants.set(scope, variant);
    return variant;
  };
  const cents = value => Math.max(0, parseInt(value, 10) || 0);
  const updateAtcPrice = scope => {
    const button = scope.querySelector('[data-sk-pdp-add-to-cart]');
    const price = button?.querySelector('[data-sk-atc-price]');
    if (!price) return;
    const compare = button.querySelector('[data-sk-atc-compare]');
    const sep = button.querySelector('.sk-atc-sep');
    const variant = scopeVariant(scope);
    const sellable = Boolean(variant && variant.available) && !atcLocked.has(button);
    [price, compare, sep].forEach(part => { if (part) part.hidden = !sellable; });
    if (!sellable) return;
    const base = cents(variant.price);
    let total = base;
    let was = Math.max(cents(variant.compare_at_price), base);
    scope.querySelectorAll('input[data-sk-addon-toggle]:checked:not(:disabled)').forEach(input => {
      const add = cents(input.dataset.priceCents);
      total += add;
      was += Math.max(cents(input.dataset.compareCents), add);
    });
    const format = button.dataset.skMoneyFormat;
    price.textContent = moneyText(format, total);
    if (compare) {
      compare.hidden = !(was > total);
      compare.textContent = was > total ? moneyText(format, was) : '';
    }
  };
  // An add-on's details panel: opened by switching the add-on on (its info button opens the pop-up below instead).
  const setAddonMore = (addon, open) => {
    const more = addon?.querySelector('[data-sk-addon-more]');
    if (!more) return;
    more.hidden = !open;
  };
  // Add-on info pop-up (snippets/sekage-pdp-addon.liquid): the (i) button opens the add-on's <dialog>. Its gallery is a
  // horizontal scroll-snap strip (swipe on touch); the arrows step one slide and wrap, the bar under it shows the position.
  const addonModalReduce = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const addonOpeners = new WeakMap();
  const addonTracks = new WeakSet();
  let addonPointerOnBackdrop = false;
  const addonModalFor = info => {
    const id = info.getAttribute('aria-controls');
    const byId = id ? document.getElementById(id) : null;
    if (byId?.matches('[data-sk-addon-modal]')) return byId;
    return info.closest('[data-sk-addon]')?.querySelector('[data-sk-addon-modal]') || null;
  };
  const addonSlideCount = track => track.querySelectorAll('[data-sk-addon-modal-slide]').length;
  const addonPosition = track => (track.clientWidth ? Math.abs(track.scrollLeft) / track.clientWidth : 0);
  const addonUpdateBar = track => {
    const bar = track.closest('[data-sk-addon-modal-gallery]')?.querySelector('[data-sk-addon-modal-bar]');
    const count = addonSlideCount(track);
    if (!bar || !count) return;
    const pos = Math.min(Math.max(addonPosition(track), 0), count - 1);
    bar.style.width = `${100 / count}%`;
    bar.style.transform = `translateX(${pos * 100}%)`;
  };
  const addonGoTo = (track, index, smooth = true) => {
    const count = addonSlideCount(track);
    if (!count) return;
    const target = ((index % count) + count) % count;
    track.scrollTo({left: target * track.clientWidth, behavior: smooth && !addonModalReduce?.matches ? 'smooth' : 'auto'});
    if (!smooth) addonUpdateBar(track);
  };
  const addonWatchTrack = track => {
    if (addonTracks.has(track)) return;
    addonTracks.add(track);
    let frame = 0;
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; addonUpdateBar(track); });
    }, {passive: true});
  };
  const openAddonModal = info => {
    const dialog = addonModalFor(info);
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    addonOpeners.set(dialog, info);
    document.documentElement.classList.add('sk-addon-modal-open');
    try { dialog.showModal(); } catch (error) { document.documentElement.classList.remove('sk-addon-modal-open'); return; }
    const track = dialog.querySelector('[data-sk-addon-modal-track]');
    if (track) {
      addonWatchTrack(track);
      addonGoTo(track, 0, false);
    }
    dialog.querySelector('.sk-addon-modal__panel')?.scrollTo?.(0, 0);
  };
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-sk-addon-modal]')) return;
    if (!document.querySelector('[data-sk-addon-modal][open]')) document.documentElement.classList.remove('sk-addon-modal-open');
    const opener = addonOpeners.get(dialog);
    addonOpeners.delete(dialog);
    if (opener?.isConnected) opener.focus({preventScroll: true});
  }, true);
  // A backdrop click lands on the dialog itself (the panel fills it); a drag that starts inside the panel never closes it.
  document.addEventListener('pointerdown', event => {
    addonPointerOnBackdrop = event.target instanceof HTMLDialogElement && event.target.matches('[data-sk-addon-modal][open]');
  }, true);
  const setupAddons = (root = document) => {
    const scopes = root.matches?.('[data-sk-product-scope]') ? [root] : [...root.querySelectorAll('[data-sk-product-scope]')];
    scopes.forEach(scope => {
      atcVariants.delete(scope);
      // Liquid hides the price for a buyable variant only when purchase is disabled (coming soon): keep it hidden.
      const button = scope.querySelector('[data-sk-pdp-add-to-cart]');
      const variant = scopeVariant(scope);
      if (button && !button.dataset.skAtcChecked) {
        button.dataset.skAtcChecked = 'true';
        if (button.querySelector('[data-sk-atc-price]')?.hidden && variant?.available) atcLocked.add(button);
      }
      // A switch restored on (back/forward cache, form autofill) also opens its details.
      scope.querySelectorAll('input[data-sk-addon-toggle]:checked').forEach(input => setAddonMore(input.closest('[data-sk-addon]'), true));
      updateAtcPrice(scope);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAddons(), {once: true});
  else setupAddons();
  document.addEventListener('shopify:section:load', event => setupAddons(event.target));
  addEventListener('pageshow', event => { if (event.persisted) setupAddons(); });
  document.addEventListener('variant-change', event => {
    const form = event.target;
    if (!(form instanceof Element)) return;
    const scope = form.closest('[data-sk-product-scope]');
    if (!scope) return;
    atcVariants.set(scope, event.detail?.variant || null);
    updateAtcPrice(scope);
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-sk-addon-toggle]')) return;
    setAddonMore(input.closest('[data-sk-addon]'), input.checked);
    const scope = input.closest('[data-sk-product-scope]');
    if (scope) updateAtcPrice(scope);
  });
  document.addEventListener('click', event => {
    const info = event.target.closest?.('[data-sk-addon-info]');
    if (info) {
      openAddonModal(info);
      return;
    }
    const modal = event.target.closest?.('[data-sk-addon-modal]');
    if (modal) {
      if (event.target === modal) {
        if (addonPointerOnBackdrop) modal.close();
        return;
      }
      if (event.target.closest('[data-sk-addon-modal-close]')) { modal.close(); return; }
      const step = event.target.closest('[data-sk-addon-modal-prev]') ? -1 : event.target.closest('[data-sk-addon-modal-next]') ? 1 : 0;
      const track = step && modal.querySelector('[data-sk-addon-modal-track]');
      if (track) addonGoTo(track, Math.round(addonPosition(track)) + step);
      return;
    }
    const all = event.target.closest?.('[data-sk-addons-all]');
    if (!all) return;
    const list = all.closest('[data-sk-addons]');
    const extras = list ? [...list.querySelectorAll('[data-sk-addon-extra][hidden]')] : [];
    extras.forEach(addon => { addon.hidden = false; });
    all.hidden = true;
    // The button is gone, so focus moves to the first add-on it revealed.
    extras[0]?.querySelector('input[data-sk-addon-toggle], [data-sk-addon-info]')?.focus({preventScroll: true});
  });

  // Product page gallery, thumbnail column (templates/product.json thumbnail_position "left", from 799px). There Turbo
  // builds no carousel for the strip (sections.js.liquid adds .vertical-slider-enabled): a click selects the slide at the
  // thumb's DOM index, and its select handler marks $thumbnails.eq(selectedIndex) from the list it saved at build time,
  // then animates the column to an offset measured before the images loaded. After a colour-set swap that saved list no
  // longer matches the column (the other sets were taken out above), so it marked a detached thumbnail. This runs after
  // Turbo's handler (a microtask after Flickity's select dispatch, which emits and then triggers the jQuery event): it
  // marks the visible thumbnail at the selected index and scrolls only the column, never the page, to keep it in view.
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const thumbColumns = new WeakSet();
  const syncThumbColumn = (nav, slider, smooth) => {
    const cells = [...nav.children].filter(cell => cell.classList.contains('gallery-cell') && !cell.hidden);
    const current = cells[slider.selectedIndex];
    nav.querySelectorAll('.gallery-cell.is-nav-selected').forEach(cell => { if (cell !== current) cell.classList.remove('is-nav-selected'); });
    if (!current) return;
    current.classList.add('is-nav-selected');
    window.jQuery?.(nav).stop(true);
    if (nav.scrollHeight <= nav.clientHeight) return;
    // 24px clears the column's scroll-edge fade (sekage-components.css).
    const edge = 24;
    const box = nav.getBoundingClientRect();
    const cell = current.getBoundingClientRect();
    let delta = 0;
    if (cell.top < box.top + edge) delta = cell.top - box.top - edge;
    else if (cell.bottom > box.bottom - edge) delta = cell.bottom - box.bottom + edge;
    if (delta) nav.scrollBy({top: delta, behavior: smooth && !reduceMotion?.matches ? 'smooth' : 'auto'});
  };
  const bindThumbColumn = wrap => {
    const gallery = wrap.querySelector('[data-product-gallery]');
    const nav = wrap.querySelector('[data-product-gallery-thumbnails]');
    if (!gallery || !nav || thumbColumns.has(nav)) return true;
    const slider = nav.classList.contains('vertical-slider-enabled') && flickityOf(gallery);
    if (!slider) return false;
    thumbColumns.add(nav);
    let queued = false;
    slider.on('select', () => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        syncThumbColumn(nav, slider, true);
      });
    });
    syncThumbColumn(nav, slider, false);
    return true;
  };
  const setupThumbColumns = (root = document) => {
    root.querySelectorAll('[data-product-gallery-wrapper]').forEach(wrap => {
      if (bindThumbColumn(wrap) || !('MutationObserver' in window)) return;
      // Turbo builds the gallery carousel and the column in one task after Flickity loads; this runs right after.
      const run = () => { if (bindThumbColumn(wrap)) watch.disconnect(); };
      const watch = new MutationObserver(run);
      [wrap.querySelector('[data-product-gallery]'), wrap.querySelector('[data-product-gallery-thumbnails]')]
        .forEach(element => element && watch.observe(element, {attributes: true, attributeFilter: ['class']}));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupThumbColumns());
  else setupThumbColumns();
  document.addEventListener('shopify:section:load', event => setupThumbColumns(event.target));

  // Product Studio counter placement and formatting are owned by sekage-storefront.js.

  // "You may also like" (sections/product-recommendations.liquid). Turbo builds a Flickity carousel on
  // .products-slider once the recommendations arrive from the recommendations endpoint. On phones
  // sekage-pages.css lays that row out as a native scroll-snap scroller, and a live Flickity blocks it
  // (touch-action:pan-y plus drag capture over neutralised transforms), so nothing moves. On phones the
  // Flickity instance is therefore removed as soon as Turbo builds it; from 768px up Turbo's carousel
  // stays as it is, and is rebuilt if a row this script unbuilt grows past 767px (rotation, resize).
  const recsPhone = window.matchMedia('(max-width:767px)');
  const recsSliders = () => document.querySelectorAll('.shopify-section--recommended-products .products-slider');
  const unbuildRecs = () => {
    if (!recsPhone.matches) return;
    recsSliders().forEach(element => {
      if (!element.classList.contains('flickity-enabled')) return;
      // Turbo builds it through the jQuery plugin, which keeps the instance in jQuery's data store.
      const slider = window.jQuery?.(element).data('flickity') || window.Flickity?.data(element);
      if (!slider) return;
      slider.destroy();
      element.dataset.skNativeRow = 'true';
    });
  };
  const recsWatch = 'MutationObserver' in window && new MutationObserver(unbuildRecs);
  const watchRecs = (root = document) => {
    if (!recsWatch) return;
    const sections = root.matches?.('.shopify-section--recommended-products') ? [root] : root.querySelectorAll('.shopify-section--recommended-products');
    sections.forEach(section => recsWatch.observe(section, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']}));
    unbuildRecs();
  };
  watchRecs();
  document.addEventListener('shopify:section:load', event => watchRecs(event.target));
  recsPhone.addEventListener?.('change', () => {
    if (recsPhone.matches) return unbuildRecs();
    const unbuilt = [...recsSliders()].filter(element => element.dataset.skNativeRow && !element.classList.contains('flickity-enabled'));
    if (!unbuilt.length) return;
    unbuilt.forEach(element => delete element.dataset.skNativeRow);
    window.productPage?.recommendedProductsSlider?.();
  });
})();
